import React from "react";
import { SEO, MainLayout, DeliveryHome } from "../../../components";

const DeliveryHomePage = () => {
  return (
    <>
      <SEO title="delivery home" />
      <MainLayout>
        <DeliveryHome />
      </MainLayout>
    </>
  );
};

export default DeliveryHomePage;
